var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.isLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中...",
      "background-color": '#ffffff'
    }
  }) : _vm._e(), _c('main', [_c('div', {
    staticClass: "px-3"
  }, [_c('h2', {
    staticClass: "section-title mt-4"
  }, [_vm._v("預選清單")]), _c('p', {
    staticClass: "total-quantity"
  }, [_vm._v("您的預選單共計"), _c('span', {
    staticClass: "total-quantity--emphasis"
  }, [_vm._v(_vm._s(_vm.totalQuantity))]), _vm._v("項商品")]), _c('div', {
    staticClass: "products"
  }, _vm._l(_vm.preorderItems, function (preorderItem, index) {
    return _c('div', {
      key: index,
      staticClass: "products__item"
    }, [_c('img', {
      staticClass: "products__item__photo",
      attrs: {
        "src": preorderItem.image
      }
    }), _c('div', {
      staticClass: "products__item__title"
    }, [_vm._v(" " + _vm._s(preorderItem.title) + " ")]), _vm.priceIsVisible ? _c('div', {
      staticClass: "products__item__price"
    }, [preorderItem.is_discounted ? [_c('span', {
      staticClass: "promoting"
    }, [_vm._v("$" + _vm._s(_vm.applyThousandsSeperator(preorderItem.discounted_price)))]), _c('span', {
      staticClass: "original-price ml-2"
    }, [_vm._v("$ " + _vm._s(_vm.applyThousandsSeperator(preorderItem.original_price)))])] : _c('div', [_vm._v("$" + _vm._s(_vm.applyThousandsSeperator(preorderItem.original_price)))])], 2) : _vm._e(), _vm.pointIsVisible ? _c('div', {
      staticClass: "products__item__price"
    }, [_c('span', {
      staticClass: "price"
    }, [_vm._v(_vm._s(preorderItem.point) + " 點")])]) : _vm._e(), _c('div', {
      staticClass: "products__item__description",
      domProps: {
        "innerHTML": _vm._s(preorderItem.description)
      }
    }), _c('div', {
      staticClass: "products__item__quantity"
    }, [_c('b-form-spinbutton', {
      staticClass: "increment-disabled decrement-disabled",
      attrs: {
        "size": "sm",
        "inline": "",
        "value": preorderItem.quantity,
        "min": "1"
      }
    })], 1)]);
  }), 0), _c('div', {
    staticClass: "divider mt-4 mb-1"
  }), _vm.priceIsVisible ? _c('div', {
    staticClass: "total-price"
  }, [_vm._v(" TOTAL "), _c('span', {
    staticClass: "total-price--emphasis ml-3 mr-2"
  }, [_vm._v(" " + _vm._s(_vm.applyThousandsSeperator(_vm.totalPrice)) + " ")]), _vm._v(" 元 ")]) : _vm._e(), _vm.pointIsVisible ? _c('div', {
    staticClass: "total-price"
  }, [_vm._v(" TOTAL "), _c('span', {
    staticClass: "total-price--emphasis ml-3 mr-2"
  }, [_vm._v(" " + _vm._s(_vm.applyThousandsSeperator(_vm.totalPoints)) + " ")]), _vm._v(" 點 ")]) : _vm._e(), _vm.terms !== null ? _c('div', {
    staticClass: "preorder-cart__terms mt-4",
    domProps: {
      "innerHTML": _vm._s(_vm.terms)
    }
  }) : _vm._e()]), _vm.topImageUrl ? _c('img', {
    staticClass: "w-100 mt-4",
    attrs: {
      "src": _vm.topImageUrl
    }
  }) : _vm._e(), _c('div', {
    staticClass: "px-3"
  }, [_c('h2', {
    staticClass: "shop-name mt-4"
  }, [_vm._v(_vm._s(_vm.deepGet(_vm.branch, 'name')))]), _c('h2', {
    staticClass: "section-title mt-4"
  }, [_vm._v("個人資料")]), _c('div', {
    staticClass: "dynamic-form mt-4"
  }, [_c('DynamicForm', {
    ref: "checkoutForm",
    attrs: {
      "input-subjects": _vm.fields,
      "value": _vm.dynamicFormValues
    }
  })], 1)]), _vm.bottomImageUrl ? _c('img', {
    staticClass: "w-100 mt-4",
    attrs: {
      "src": _vm.bottomImageUrl
    }
  }) : _vm._e()]), _c('footer', {
    staticClass: "sticky-bottom footer-action-bar"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }